module.exports = __webpack_public_path__ + "img/imgs7.2a00af7f.png";